import { RowActions } from '@app/components/table/RowActions';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { ShowOnStreamAction } from '@app/modules/audit/components/ShowOnStreamAction';
import { AuditSchedule } from '@mi-front/core';
import { Box } from '@mui/material';
import { getScheduleStreamMatch } from './schedule-status-spot-utils';

interface ScheduleStatusSpotDetailScheduleActionsProps {
  schedule: AuditSchedule;
}

/**
 * Row actions for a schedule in the detail dialog (logger stream at match time).
 */
export function ScheduleStatusSpotDetailScheduleActions({
  schedule,
}: ScheduleStatusSpotDetailScheduleActionsProps) {
  const station = useActiveStation();
  const match = getScheduleStreamMatch(schedule);

  if (!match) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <RowActions>
        <ShowOnStreamAction
          station={station.slug}
          datetime={match.datetime}
          durationMs={match.durationMs}
          tab={match.tab}
        />
      </RowActions>
    </Box>
  );
}
